import { FC } from "react";
import { TableCell, TableRow, TextField } from "@mui/material";
import { ArticleRow, EditCout } from "./AddCoutForm";
import CheckAttr from "../../../utils/CheckAttr";

interface RowInAssociationProps {
    article: ArticleRow;
    handleChangeCout: (editCout: EditCout) => void;
}

const EachRowInAssociation: FC<RowInAssociationProps> = ({ article, handleChangeCout }) => {

    const handleChange = (e: any) => {
        const editCout: EditCout = {
            idPivot: article?.id_association,
            idArticle: article?.id,
            coutactivite: e.target.value
        };

        handleChangeCout(editCout);
    };

    return (
        <TableRow key={article?.id}>
            <TableCell align="center">
                {article?.code_article?.libelle}
            </TableCell>
            <TableCell align="center">
                {article?.libelle}
            </TableCell>
            <TableCell align="center">
                <TextField
                    name="coutactivite"
                    color="warning"
                    variant="filled"
                    size="small"
                    type="number"
                    autoComplete="off"
                    placeholder="Ex: 2.02"
                    inputProps={{
                        step: 0.01,
                        lang: 'en-US'
                    }}
                    value={article?.cout?.coutactivite}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: CheckAttr(article?.cout?.coutactivite)
                    }}
                />
            </TableCell>
            <TableCell align="center">
                {article?.devise?.libelle}
            </TableCell>
            <TableCell align="center">
                <TextField
                    name="date_debut"
                    label="Date debut"
                    type="date"
                    color="warning"
                    fullWidth
                    disabled
                    // error={errorInput.date_debut}
                    value={article?.cout?.date_debut}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </TableCell>
            <TableCell align="center">
                <TextField
                    name="date_fin"
                    label="Date fin"
                    type="date"
                    color="warning"
                    fullWidth
                    disabled
                    // error={errorInput.date_fin}
                    value={article?.cout?.date_fin}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </TableCell>
        </TableRow>
    );
};

export default EachRowInAssociation;